import { createSelector } from 'reselect';

type ApmState = ReturnType<typeof selectApm>;

function selectApm(state: AppState) {
  return state.apm;
}

export const selectIsApmEnabled = createSelector<AppState, ApmState, boolean | null>(
  [selectApm],
  (apm) => {
    return apm.IsApmEnabled;
  }
);
